"use client"

import { useEffect, useRef } from 'react'

const Ad = ({ slot, format = 'auto', responsive = 'true' }: {
    slot: string,
    format?: string,
    responsive?: string
}) => {
    const adRef = useRef<HTMLModElement>(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const el = adRef.current;
        if (!el) return;

        const ro = new ResizeObserver(entries => {
            for (const entry of entries) {
                if (entry.contentRect.width > 0) {
                    try {
                        (window as any).adsbygoogle = (window as any).adsbygoogle || [];
                        (window as any).adsbygoogle.push({});
                    } catch (e) {
                        console.error('AdSense push error:', e);
                    }
                    ro.disconnect();
                }
            }
        });

        ro.observe(el);
        return () => ro.disconnect();
    }, [slot]);

    return (
        <ins className="adsbygoogle w-full max-w-5xl mx-auto mt-8"
            style={{ display: 'block' }}
            data-ad-client={"ca-pub-2857745303000128"}
            data-ad-slot={slot}
            data-ad-format={format}
            data-full-width-responsive={responsive}
            ref={adRef}
        ></ins>
    );
};

export default Ad;